<app-s01-navigation></app-s01-navigation>
<main class="watchlist-page" #watchlistRef>
  <app-a04-picture-element
    width="1920"
    height="1080"
    webpSrcset="{{ '/assets/images/background/background-light.webp' | assetpipe }}"
    defaultSrc="{{ '/assets/images/background/background-light.jpg' | assetpipe }}"
    alt=""
    class="browse-title-background"
  >
  </app-a04-picture-element>
  <app-c01-tv-frame customClass="page-tv-frame">
    <img
      data-transition="4"
      src="{{ '/assets/images/watchlist-page/4.jpg' | assetpipe }}"
      alt=""
      class="watchlist-img"
    />
    <img
      data-transition="3"
      src="{{ '/assets/images/watchlist-page/3.jpg' | assetpipe }}"
      alt=""
      class="watchlist-img"
    />
    <img
      data-transition="2"
      src="{{ '/assets/images/watchlist-page/2.jpg' | assetpipe }}"
      alt=""
      class="watchlist-img"
    />
    <img
      data-transition="1"
      src="{{ '/assets/images/watchlist-page/1.jpg' | assetpipe }}"
      alt=""
      class="watchlist-img"
    />
  </app-c01-tv-frame>
  <app-c02-remote-control-buttons
    [tooltipCopy]="currentStep.tooltipCopy"
    [featureName]="featureName"
    [stepIndex]="stepIndex"
    [buttons]="currentStep.activeButtonKeys"
    [disabled]="isRemoteDisabled"
  ></app-c02-remote-control-buttons>
  <app-c04-opening-screen [featureName]="featureName"></app-c04-opening-screen>
  <div data-animation="devices-screen-wrapper" class="devices-intro-copy-wrapper">
    <span data-animation="devices-overlay" class="overlay"></span>
    <h2 data-animation="devices-title" aria-live="assertive" class="intro-copy">
      {{ copy }}
    </h2>
    <div
      class="lottie-wrapper"
      role="img"
      aria-live="assertive"
      aria-label="Google search of Gardening Australia, a serie from 1990. In the search overview, the serie information is displayed with a Watchlist button that is selected and turns green."
    >
      <ng-lottie
        width="100%"
        height="100%"
        [options]="lottieOptions"
        (animationCreated)="animationCreated($event)"
        (complete)="onLottieEnd()"
      ></ng-lottie>
    </div>
  </div>
  <app-c06-end-screen [featureName]="featureName"></app-c06-end-screen>
  <app-a03-disclaimer-paragraph [featureName]="featureName"></app-a03-disclaimer-paragraph>
  <app-a05-custom-cta></app-a05-custom-cta>
  <app-c03-question-mark-modal [featureName]="featureName"></app-c03-question-mark-modal>
</main>
